<template>
  <div class="flex items-center gap-8 overflow-auto pr-6">
    <template v-for="menu in MENU_TOP" :key="menu.id">
      <a-dropdown v-if="menu.type === 'dropdown'" v-model:open="menu.open">
        <a class="flex items-center gap-1" @click.prevent>
          <strong class="uppercase text-[15px] text-primary whitespace-nowrap">
            {{ menu.name }}
          </strong>
          <DownOutlined :style="{ color: 'var(--color-primary)' }" />
        </a>

        <template #overlay>
          <a-menu>
            <a-menu-item
              v-for="m in menu.children"
              :key="m.id"
              class="text-primary font-semibold hover:bg-primary hover:text-white"
              @click="handleMenuClick(m)"
            >
              {{ m.name }}
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>

      <strong
        v-else
        :class="[
          `uppercase text-[15px] mr-1 text-primary ${
            menu.isCurrent ? 'underline' : ''
          } underline-offset-4 whitespace-nowrap cursor-pointer`
        ]"
        @click="handleTopMenuClick(menu)"
      >
        {{ menu.name }}
      </strong>
    </template>
  </div>
</template>
<script lang="ts" setup>
import { DownOutlined } from '@ant-design/icons-vue'
import { MENU_TOP } from '@/components/menu-top/config.ts'
import { Modal } from 'ant-design-vue'
import { authAPI } from '@/apis/auth'
import { useAuthStore } from '@/stores/authStore.ts'
import { h } from 'vue'
import { MenuTopType } from '@/types'

const authStore = useAuthStore()
const userInfo = authStore.auth.userInfo

const handleMenuClick = async (menu: MenuTopType) => {
  if (!menu.url) return
  Modal.confirm({
    title: h('p', ['Bạn có muốn tiếp tục đăng nhập với ứng dụng ', h('strong', menu.name), '?']),
    okText: 'Tiếp tục',
    cancelText: 'Hủy bỏ',
    width: 450,
    onOk() {
      if (menu.clientId) {
        return new Promise((resolve, reject) => {
          const refreshToken = authStore.auth.refreshToken
          const memberCompanyId = authStore.auth.memberCompanyId
          const memberCompanyCode = authStore.auth.memberCompanyCode

          authAPI
            .exchangeToken({
              refreshToken,
              clientId: menu.clientId,
              username: userInfo?.userName || ''
            })
            .then((res) => {
              if (res.message === 'SUCCESS') {
                const { refresh_token, access_token, mqttToken } = res.body
                if (
                  ![
                    'WP_HRM',
                    'WP_PJM',
                    'WP_WDNM',
                    'WP_BOC',
                    'WP_WTPM',
                    'WP_ASM',
                    'WP_CCM'
                  ].includes(menu.clientId)
                ) {
                  const params = `refresh_token=${refresh_token}&access_token=${access_token}&mqttToken=${mqttToken}&memberCompanyId=${memberCompanyId}&memberCompanyCode=${memberCompanyCode}`
                  window.open(`${menu.url}/login?${params}`, '_blank')
                } else {
                  const data = {
                    ...res.body,
                    memberCompanyId: memberCompanyId,
                    memberCompanyCode: memberCompanyCode,
                    redirect: '',
                    username: userInfo?.userName || ''
                  }

                  const form = document.createElement('form')
                  form.method = 'POST'
                  form.action = menu.url + '/api/auth/login'
                  form.target = '_blank'

                  Object.entries(data).forEach(([key, value]) => {
                    const input = document.createElement('input')
                    input.type = 'hidden'
                    input.name = key
                    input.value = value
                    form.appendChild(input)
                  })

                  document.body.appendChild(form)
                  form.submit()
                }
                resolve(res.body)
              }
            })
            .catch((e) => reject(e))
        })
      }
      window.open(menu.url, '_blank');
    }
  })
}

const handleTopMenuClick = (menu: MenuTopType) => {
  const { url } = menu
  if (!url) return

  handleMenuClick(menu)
}
</script>
